module.exports = __webpack_public_path__ + "img/gywm.b387e900.jpg";